export const COLOR_MAP_DEVICE: Record<string, string> = {
  Desktop: 'var(--pie-chart-1)',
  Mobile: 'var(--pie-chart-2)',
  Tablet: 'var(--pie-chart-3)',
  Other: 'var(--pie-chart-4)',
};

export const COLOR_MAP_BROWSER: Record<string, string> = {
  Chrome: 'var(--pie-chart-1)',
  Safari: 'var(--pie-chart-2)',
  Firefox: 'var(--pie-chart-3)',
  Edge: 'var(--pie-chart-4)',
  Opera: 'var(--pie-chart-5)',
  Other: 'var(--pie-chart-6)',
};

export const COLOR_MAP_OS: Record<string, string> = {
  Windows: 'var(--pie-chart-1)',
  macOS: 'var(--pie-chart-2)',
  Linux: 'var(--pie-chart-3)',
  Android: 'var(--pie-chart-4)',
  iOS: 'var(--pie-chart-5)',
  Other: 'var(--pie-chart-6)',
};
